var map = {
	"./brand/reduced": 204,
	"./brand/reduced.svg": 204,
	"./brand/regular": 205,
	"./brand/regular.svg": 205,
	"./favicons/favicon-16x16": 206,
	"./favicons/favicon-16x16.png": 206,
	"./favicons/favicon-32x32": 207,
	"./favicons/favicon-32x32.png": 207,
	"./favicons/favicon-96x96": 208,
	"./favicons/favicon-96x96.png": 208,
	"./menu/event_logo": 209,
	"./menu/event_logo.png": 209,
	"./menu/logo": 210,
	"./menu/logo.svg": 210,
	"./menu/user": 211,
	"./menu/user.svg": 211,
	"./spinner": 212,
	"./spinner.svg": 212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;